import APIService from '@/services/APIService.js';

export default {
  getDados() {
    return APIService.apiCall().get('/dadosAreaConcessao/getDados');
  }
};
